export const SERVICES = [
  {
    slug: "sistemas",
    title: "Sistemas sob medida",
    short: "Produtos digitais construídos ao redor da sua operação, sem obrigar sua empresa a se adaptar a uma ferramenta genérica.",
    detail: "Mapeamos fluxos, perfis de acesso, integrações e regras do negócio para transformar necessidades reais em uma solução clara, segura e preparada para evoluir.",
    tags: ["Produto digital", "Painéis", "Integrações"],
  },
  {
    slug: "crm",
    title: "CRM e vendas",
    short: "Organização de contatos, atendimentos e oportunidades em um fluxo comercial que a equipe consegue acompanhar.",
    detail: "Criamos CRMs personalizados do zero e adaptamos soluções já desenvolvidas para centralizar informações e dar visibilidade às etapas do processo comercial.",
    tags: ["Pipeline", "Atendimento", "Gestão"],
  },
  {
    slug: "automacao",
    title: "Automação e IA",
    short: "Conversas, tarefas e rotinas conectadas para reduzir trabalho manual e acelerar respostas.",
    detail: "Desenhamos automações para WhatsApp, menus inteligentes e experiências assistidas por IA, sempre de acordo com a operação e o tom de cada empresa.",
    tags: ["WhatsApp", "Agentes de IA", "Fluxos"],
  },
  {
    slug: "web",
    title: "Sites e experiências web",
    short: "Presença digital com estratégia, performance e uma experiência visual à altura do seu negócio.",
    detail: "Desenvolvemos sites institucionais e páginas de campanha responsivas, rápidas e preparadas para apresentar serviços, produtos e diferenciais com clareza.",
    tags: ["Sites", "Landing pages", "Interfaces"],
  },
];

export const PROCESS = [
  { title: "Entendimento", text: "Entramos na operação para entender o problema, as pessoas envolvidas e o que precisa mudar." },
  { title: "Direção", text: "Definimos prioridades, arquitetura, experiência e o caminho mais eficiente para o projeto." },
  { title: "Construção", text: "Desenvolvemos em ciclos curtos, tornando decisões e evolução visíveis ao longo do processo." },
  { title: "Validação", text: "Testamos os fluxos, refinamos a experiência e ajustamos o produto com base no uso real." },
  { title: "Evolução", text: "Entregamos uma base organizada e preparada para receber novas etapas quando o negócio pedir." },
];
